(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["instagram-social-feed"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-iamsoreal-instagram]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const endpoint = root.dataset.feedEndpoint;
    const status = root.querySelector('[data-instagram-status]');
    const searchParams = new URLSearchParams(window.location.search);
    const uploadRequestedOnLoad = searchParams.get('iamsoreal_upload') === '1' || sessionStorage.getItem('iamsoreal_upload_pending') === '1';
    const returnedFromLogin = searchParams.get('iamsoreal_auth') === 'success' || sessionStorage.getItem('iamsoreal_upload_pending') === '1';
    let contentRotationTimer;
    let carouselRotationTimer;
    let automaticTabChange = false;
    const escapeText = (value) => String(value || '').replace(/[&<>\"']/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#039;'}[character]));
    const productTags = new Map();
    Array.from(document.querySelectorAll('[data-iamsoreal-product-tag]')).forEach((tag) => {
      const postId = String(tag.dataset.postId || '');
      if (!postId) return;
      const products = productTags.get(postId) || [];
      const product = {title:tag.dataset.productTitle,url:tag.dataset.productUrl,price:tag.dataset.productPrice,variantId:tag.dataset.productVariantId,available:tag.dataset.productAvailable === 'true',slideIndex:Math.max(1, Number(tag.dataset.slideIndex || 1))};
      if (!products.some((item) => item.variantId === product.variantId && item.slideIndex === product.slideIndex)) products.push(product);
      productTags.set(postId, products);
    });
    const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= .35) video.play().catch(() => {});
        else video.pause();
      });
    }, {threshold:[0,.35,.75]}) : null;
    const observeVideos = (container) => {
      container.querySelectorAll('[data-feed-video]').forEach((video) => {
        if (videoObserver) videoObserver.observe(video);
        else video.play().catch(() => {});
      });
    };
    const mediaMarkup = (item) => {
      const source = item.thumbnail_url || item.media_url;
      if (!source) return '';
      const taggedProducts = productTags.get(String(item.id)) || [];
      const productTag = taggedProducts.map((taggedProduct, index) => `<span class="iamsoreal-instagram__product-actions" style="bottom:${8 + index * 36}px"><a class="iamsoreal-instagram__product" href="${escapeText(taggedProduct.url)}">SHOP ${escapeText(taggedProduct.title)}${taggedProduct.price ? ` · ${escapeText(taggedProduct.price)}` : ''}</a><button class="iamsoreal-instagram__product-add" type="button" data-product-add="${escapeText(taggedProduct.variantId)}" ${taggedProduct.available ? '' : 'disabled'}>${taggedProduct.available ? 'ADD TO CART' : 'SOLD OUT'}</button></span>`).join('');
      const slides = Array.isArray(item.children) && item.children.length ? item.children : [item];
      const slideMarkup = slides.map((slide) => {
        const mediaSource = slide.media_url || slide.thumbnail_url;
        const posterSource = slide.thumbnail_url || '';
        const mediaType = String(slide.media_type || slide.mediaType || slide.type || '').toUpperCase();
        const contentType = String(slide.content_type || slide.contentType || '').toLowerCase();
        const isVideo = mediaType.includes('VIDEO') || contentType.startsWith('video/') || /\.(mp4|mov|m4v|webm)(?:\?|$)/i.test(mediaSource);
        const media = isVideo ? `<video data-feed-video muted loop playsinline preload="metadata" ${posterSource && posterSource !== mediaSource ? `poster="${escapeText(posterSource)}"` : ''}><source src="${escapeText(mediaSource)}"${contentType ? ` type="${escapeText(contentType)}"` : ''}></video>` : `<img src="${escapeText(posterSource || mediaSource)}" alt="" loading="lazy" decoding="async">`;
        return `<a class="iamsoreal-instagram__tile-slide" href="${escapeText(item.permalink)}" target="_blank" rel="noopener noreferrer" aria-label="View ${escapeText(item.account_label)} post">${media}</a>`;
      }).join('');
      const controls = slides.length > 1 ? `<button class="iamsoreal-instagram__tile-button iamsoreal-instagram__tile-button--previous" type="button" data-tile-previous aria-label="Previous photo">‹</button><button class="iamsoreal-instagram__tile-button iamsoreal-instagram__tile-button--next" type="button" data-tile-next aria-label="Next photo">›</button><span class="iamsoreal-instagram__tile-count" data-tile-count>1/${slides.length}</span>` : '';
      return `<article class="iamsoreal-instagram__tile"><div class="iamsoreal-instagram__tile-carousel" data-tile-carousel>${slideMarkup}</div>${controls}<span class="iamsoreal-instagram__account">${item.account_icon || '@'} ${escapeText(item.account_label)}</span>${productTag}</article>`;
    };
    const renderPanel = (name, items) => {
      const panel = root.querySelector(`[data-instagram-panel="${name}"]`);
      if (panel) {
        panel.innerHTML = items.map(mediaMarkup).join('');
        observeVideos(panel);
      }
    };
    root.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-product-add]');
      if (addButton) {
        event.preventDefault();
        addButton.disabled = true;
        fetch(root.dataset.cartAddUrl, {method:'POST',headers:{'content-type':'application/json','accept':'application/json'},body:JSON.stringify({items:[{id:Number(addButton.dataset.productAdd),quantity:1}]})})
          .then((response) => { if (!response.ok) throw new Error('Unable to add product'); return fetch(`${root.dataset.cartUrl}.js`, {headers:{accept:'application/json'}}); })
          .then((response) => response.json())
          .then((cart) => {
            document.querySelectorAll('[data-iamsoreal-cart-count]').forEach((link) => { link.textContent = `CART (${cart.item_count})`; });
            addButton.textContent = 'ADDED ✓';
            window.setTimeout(() => { addButton.textContent = 'ADD TO CART'; addButton.disabled = false; }, 1800);
          })
          .catch(() => { addButton.textContent = 'TRY AGAIN'; addButton.disabled = false; });
        return;
      }
      const button = event.target.closest('[data-tile-previous],[data-tile-next]');
      if (!button) return;
      const tile = button.closest('.iamsoreal-instagram__tile');
      const carousel = tile?.querySelector('[data-tile-carousel]');
      if (!carousel) return;
      const direction = button.hasAttribute('data-tile-next') ? 1 : -1;
      carousel.scrollBy({left:direction * carousel.clientWidth,behavior:'smooth'});
    });
    const pauseTileCarousel = (tile, paused = true) => {
      if (!tile) return;
      tile.dataset.carouselPaused = paused ? 'true' : 'false';
    };
    root.addEventListener('pointerover', (event) => pauseTileCarousel(event.target.closest?.('.iamsoreal-instagram__tile')));
    root.addEventListener('pointerout', (event) => {
      const tile = event.target.closest?.('.iamsoreal-instagram__tile');
      if (!tile || tile.contains(event.relatedTarget)) return;
      pauseTileCarousel(tile, false);
    });
    root.addEventListener('focusin', (event) => pauseTileCarousel(event.target.closest?.('.iamsoreal-instagram__tile')));
    root.addEventListener('focusout', (event) => {
      const tile = event.target.closest?.('.iamsoreal-instagram__tile');
      if (!tile || tile.contains(event.relatedTarget)) return;
      pauseTileCarousel(tile, false);
    });
    root.addEventListener('touchstart', (event) => {
      const tile = event.target.closest?.('.iamsoreal-instagram__tile');
      pauseTileCarousel(tile);
      window.setTimeout(() => pauseTileCarousel(tile, false), 8000);
    }, {passive:true});
    root.addEventListener('scroll', (event) => {
      const carousel = event.target.closest?.('[data-tile-carousel]');
      if (!carousel) return;
      const count = carousel.closest('.iamsoreal-instagram__tile')?.querySelector('[data-tile-count]');
      if (!count) return;
      const total = carousel.children.length;
      const current = Math.min(total, Math.max(1, Math.round(carousel.scrollLeft / carousel.clientWidth) + 1));
      count.textContent = `${current}/${total}`;
    }, true);
    const renderStories = (items) => {
      const stories = root.querySelector('[data-instagram-stories]');
      stories.innerHTML = items.map((item) => `<a class="iamsoreal-instagram__story" href="${escapeText(item.permalink)}" target="_blank" rel="noopener noreferrer" aria-label="View ${escapeText(item.account_label)} story"><img src="${escapeText(item.thumbnail_url || item.media_url)}" alt="" loading="lazy"></a>`).join('');
      stories.hidden = items.length === 0;
    };
    root.querySelectorAll('[data-instagram-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        if (!automaticTabChange && contentRotationTimer) {
          window.clearInterval(contentRotationTimer);
          contentRotationTimer = undefined;
        }
        root.querySelectorAll('[data-instagram-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        root.querySelectorAll('[data-instagram-panel]').forEach((panel) => { panel.hidden = panel.dataset.instagramPanel !== tab.dataset.instagramTab; });
      });
    });
    const openUploadFromReturn = () => {
      if (!uploadRequestedOnLoad) return;
      const uploadTab = root.querySelector('[data-instagram-tab="upload"]');
      const uploadPanel = root.querySelector('[data-instagram-panel="upload"]');
      if (!uploadTab || !uploadPanel) return;
      uploadTab.click();
      sessionStorage.removeItem('iamsoreal_upload_pending');
      window.requestAnimationFrame(() => {
        uploadPanel.scrollIntoView({behavior:'smooth',block:'start'});
        window.history.replaceState({}, '', `${window.location.pathname}#IamsorealInstagramUpload`);
      });
    };
    openUploadFromReturn();
    window.addEventListener('pageshow', openUploadFromReturn, {once:true});

    const uploadForm = root.querySelector('[data-iamsoreal-upload-form]');
    const uploadAuthSuccess = root.querySelector('[data-upload-auth-success]');
    if (uploadAuthSuccess) uploadAuthSuccess.hidden = !returnedFromLogin;
    if (uploadForm) {
      const fileInput = uploadForm.querySelector('[data-upload-file]');
      const fileLabel = uploadForm.querySelector('[data-upload-file-label]');
      const drop = uploadForm.querySelector('[data-upload-drop]');
      const filesPreview = uploadForm.querySelector('[data-upload-files]');
      const button = uploadForm.querySelector('[data-upload-submit]');
      const message = uploadForm.querySelector('[data-upload-message]');
      const progress = uploadForm.querySelector('[data-upload-progress]');
      const progressBar = uploadForm.querySelector('[data-upload-progress-bar]');
      const setMessage = (text, error = false) => {
        message.textContent = text;
        message.classList.toggle('is-error', error);
      };
      let selectedFiles = [];
      let previewUrls = [];
      const formatBytes = (bytes) => {
        if (bytes >= 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
        if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
        return `${Math.max(1, Math.round(bytes / 1024))} KB`;
      };
      const syncInputFiles = () => {
        if (typeof DataTransfer === 'undefined') return;
        const transfer = new DataTransfer();
        selectedFiles.forEach((file) => transfer.items.add(file));
        fileInput.files = transfer.files;
      };
      const renderSelectedFiles = () => {
        previewUrls.forEach((url) => URL.revokeObjectURL(url));
        previewUrls = selectedFiles.map((file) => URL.createObjectURL(file));
        filesPreview.innerHTML = selectedFiles.map((file, index) => {
          const source = escapeText(previewUrls[index]);
          const preview = file.type.startsWith('video/')
            ? `<video src="${source}" muted playsinline preload="metadata"></video>`
            : `<img src="${source}" alt="Preview of ${escapeText(file.name)}">`;
          return `<article class="iamsoreal-upload__file"><span class="iamsoreal-upload__file-number">${index + 1}</span><button class="iamsoreal-upload__file-remove" type="button" data-remove-upload-file="${index}" aria-label="Remove ${escapeText(file.name)}">×</button><span class="iamsoreal-upload__file-preview">${preview}</span><div class="iamsoreal-upload__file-meta"><strong title="${escapeText(file.name)}">${escapeText(file.name)}</strong><small>${escapeText(file.type || 'Media')} · ${formatBytes(file.size)}</small></div></article>`;
        }).join('');
        filesPreview.hidden = selectedFiles.length === 0;
        fileLabel.textContent = selectedFiles.length === 1 ? '1 FILE IN BATCH — ADD MORE' : selectedFiles.length > 1 ? `${selectedFiles.length} FILES IN BATCH — ADD MORE` : 'CHOOSE PHOTOS OR VIDEOS';
        drop.classList.toggle('has-file', selectedFiles.length > 0);
      };
      fileInput.addEventListener('change', () => {
        const addedFiles = Array.from(fileInput.files || []);
        const existingKeys = new Set(selectedFiles.map((file) => `${file.name}:${file.size}:${file.lastModified}`));
        addedFiles.forEach((file) => {
          const key = `${file.name}:${file.size}:${file.lastModified}`;
          if (!existingKeys.has(key)) {
            selectedFiles.push(file);
            existingKeys.add(key);
          }
        });
        syncInputFiles();
        renderSelectedFiles();
      });
      filesPreview.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-upload-file]');
        if (!removeButton) return;
        selectedFiles.splice(Number(removeButton.dataset.removeUploadFile), 1);
        syncInputFiles();
        renderSelectedFiles();
      });
      uploadForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const files = selectedFiles.slice();
        if (!files.length) return setMessage('Choose at least one photo or video first.', true);
        if (files.some((file) => !/^(image|video)\//.test(file.type))) return setMessage('Every file must be a supported photo or video.', true);
        if (files.some((file) => file.size > 1024 * 1024 * 1024)) return setMessage('Each file must be 1 GB or smaller.', true);
        button.disabled = true;
        progress.hidden = false;
        progressBar.style.width = '2%';
        setMessage(`Preparing ${files.length} ${files.length === 1 ? 'file' : 'files'}…`);
        try {
          const submissionGroupId = window.crypto?.randomUUID ? window.crypto.randomUUID() : `group-${Date.now()}-${Math.random().toString(16).slice(2)}`;
          for (let index = 0; index < files.length; index += 1) {
            const file = files[index];
            const baseProgress = index / files.length;
            setMessage(`Preparing file ${index + 1} of ${files.length}…`);
            progressBar.style.width = `${Math.round((baseProgress + .08 / files.length) * 100)}%`;
            const prepared = await fetch('/apps/gsuwoo/uploads/presign', {
              method: 'POST',
              headers: {'content-type':'application/json','accept':'application/json'},
              body: JSON.stringify({filename:file.name,contentType:file.type,size:file.size,submissionGroupId})
            });
            const upload = await prepared.json().catch(() => ({}));
            if (prepared.status === 401) throw new Error('The uploader could not be verified. Refresh this page and try again.');
            if (!prepared.ok) throw new Error(upload.error || `File ${index + 1} could not be prepared.`);
            setMessage(`Uploading file ${index + 1} of ${files.length}…`);
            progressBar.style.width = `${Math.round((baseProgress + .35 / files.length) * 100)}%`;
            const stored = await fetch(upload.uploadUrl, {method:'PUT',headers:{'content-type':file.type},body:file});
            if (!stored.ok) throw new Error(`File ${index + 1} failed to upload. Please try again.`);
            setMessage(`Submitting file ${index + 1} of ${files.length} for review…`);
            progressBar.style.width = `${Math.round((baseProgress + .82 / files.length) * 100)}%`;
            const submitted = await fetch('/apps/gsuwoo/community/submissions', {
              method:'POST',
              headers:{'content-type':'application/json','accept':'application/json'},
              body:JSON.stringify({mediaKey:upload.key,mediaType:file.type.startsWith('video/')?'video':'image',contentType:file.type,size:file.size,caption:uploadForm.elements.caption.value.trim(),uploaderName:uploadForm.elements.uploaderName.value.trim(),instagramUsername:uploadForm.elements.instagramUsername.value.trim(),tiktokUsername:uploadForm.elements.tiktokUsername.value.trim(),twitterUsername:uploadForm.elements.twitterUsername.value.trim(),facebookUsername:uploadForm.elements.facebookUsername.value.trim(),city:uploadForm.elements.city.value.trim(),region:uploadForm.elements.region.value.trim(),country:uploadForm.elements.country.value.trim(),submissionGroupId,sortOrder:index,termsAccepted:true})
            });
            const result = await submitted.json().catch(() => ({}));
            if (!submitted.ok) throw new Error(result.error || `File ${index + 1} could not be submitted.`);
          }
          progressBar.style.width = '100%';
          setMessage(`${files.length} ${files.length === 1 ? 'file' : 'files'} submitted. We will review ${files.length === 1 ? 'it' : 'them'} before ${files.length === 1 ? 'it appears' : 'they appear'} in the feed.`);
          uploadForm.reset();
          selectedFiles = [];
          renderSelectedFiles();
        } catch (error) {
          progressBar.style.width = '0';
          setMessage(error.message || 'Something went wrong. Please try again.', true);
        } finally {
          button.disabled = false;
          window.setTimeout(() => { progress.hidden = true; }, 800);
        }
      });
    }

    const loadFeed = () => {
      if (!endpoint) { status.textContent = 'Instagram feed connection is not configured.'; return; }
      const instagramRequest = fetch(endpoint, { headers: { accept: 'application/json' } })
        .then((response) => { if (!response.ok) throw new Error('Feed unavailable'); return response.json(); });
      const communityRequest = fetch(`/apps/gsuwoo/community?limit=24&_=${Date.now()}`, { headers: { accept: 'application/json' }, cache: 'no-store' })
        .then((response) => response.ok ? response.json() : {posts:[]})
        .catch(() => ({posts:[]}));
      Promise.all([instagramRequest, communityRequest])
        .then(([feed, community]) => {
          const communityPosts = (community.posts || []).map((post) => {
            const slides = Array.isArray(post.slides) && post.slides.length ? post.slides : [post];
            const communitySlides = slides.map((slide) => ({
              media_url: slide.mediaUrl,
              thumbnail_url: slide.thumbnailUrl || slide.mediaUrl,
              media_type: slide.mediaType,
              content_type: slide.contentType
            })).filter((slide) => slide.media_url || slide.thumbnail_url);
            const first = communitySlides[0] || {};
            return {
              id: `community-${post.id}`,
              account_icon: '📍',
              account_label: 'SO REAL GSUWOO®',
              permalink: first.media_url || first.thumbnail_url || '#',
              media_url: first.media_url,
              thumbnail_url: first.thumbnail_url,
              children: communitySlides
            };
          }).filter((post) => post.media_url || post.thumbnail_url);
          const ugcPosts = [...communityPosts, ...(feed.ugc || [])];
          renderStories(feed.stories || []);
          renderPanel('posts', feed.posts || []);
          renderPanel('ugc', ugcPosts);
          if (!carouselRotationTimer) {
            carouselRotationTimer = window.setInterval(() => {
              root.querySelectorAll('[data-tile-carousel]').forEach((carousel) => {
                const tile = carousel.closest('.iamsoreal-instagram__tile');
                const total = carousel.children.length;
                if (total < 2 || tile?.dataset.carouselPaused === 'true' || carousel.offsetParent === null) return;
                const current = Math.round(carousel.scrollLeft / Math.max(carousel.clientWidth, 1));
                const next = (current + 1) % total;
                carousel.scrollTo({left:next * carousel.clientWidth,behavior:'smooth'});
              });
            }, 4500);
          }
          status.hidden = true;
          if (!uploadRequestedOnLoad && (feed.posts || []).length && ugcPosts.length) {
            const alternatingTabs = ['posts', 'ugc'];
            let alternatingIndex = 0;
            contentRotationTimer = window.setInterval(() => {
              alternatingIndex = (alternatingIndex + 1) % alternatingTabs.length;
              const nextTab = root.querySelector(`[data-instagram-tab="${alternatingTabs[alternatingIndex]}"]`);
              if (!nextTab) return;
              automaticTabChange = true;
              nextTab.click();
              automaticTabChange = false;
            }, 10000);
          }
        })
        .catch(() => { status.textContent = 'Instagram feed is temporarily unavailable.'; });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { loadFeed(); observer.disconnect(); }
        });
      }, { rootMargin: '400px' });
      observer.observe(root);
    } else { loadFeed(); }
  })();
  } catch(e) { console.error(e); }
})();

})();
